import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const SuggestionsContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background: transparent;
  margin-top: ${({ theme: { token } }) => token.marginXL * 2}px;
`;

export const HeroContent = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  max-width: 1240px;
  width: 100%;
  margin: 0 auto ${({ theme: { token } }) => token.marginLG}px;
  z-index: 2;
  position: relative;
`;

export const HeroTitle = styled.h1<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeHeading2}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  margin: 0 0 ${({ theme: { token } }) => token.margin}px 0;
  width: 620px;
  background: linear-gradient(
    90deg,
    ${({ theme: { token } }) => token.colorTextLightSolid || '#ffffff'} 0%,
    ${({ theme: { token } }) => token.colorTextLightSolid || '#ffffff'} 58.864%,
    ${({ theme: { token } }) => token.colorPrimary} 83.735%,
    ${({ theme: { token } }) => token.colorPrimary} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  text-align: left;
`;

export const HeroSubtitle = styled.p<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorTextSecondary};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  margin: 0;
  max-width: 890px;
  text-align: left;
`;

export const PromptsGrid = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
